// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyFilterResult__container","icon":"EmptyFilterResult__icon"};